import React from "react";

export default (props) => (
  <svg
    {...props}
    viewBox="0 0 23 23"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="path0_fill"
      fillRule="evenodd"
      d="M 16.4286 14.4571L 15.3771 14.4571L 14.9829 14.0629C 16.2971 12.6171 17.0857 10.6457 17.0857 8.54286C 17.0857 3.81143 13.2743 0 8.54286 0C 3.81143 0 0 3.81143 0 8.54286C 0 13.2743 3.81143 17.0857 8.54286 17.0857C 10.6457 17.0857 12.6171 16.2971 14.0629 14.9829L 14.4571 15.3771L 14.4571 16.4286L 21.0286 23L 23 21.0286L 16.4286 14.4571ZM 8.5427 14.4572C 5.25699 14.4572 2.62842 11.8286 2.62842 8.54289C 2.62842 5.25717 5.25699 2.6286 8.5427 2.6286C 11.8284 2.6286 14.457 5.25717 14.457 8.54289C 14.457 11.8286 11.8284 14.4572 8.5427 14.4572Z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/nekrasovka-ui/Icons/svg/Search/index.js